import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import ThemeProvider from './theme/ThemeProvider';
import ErrorBoundary from './components/ErrorBoundary';

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode><ErrorBoundary><ThemeProvider><App /></ThemeProvider></ErrorBoundary></React.StrictMode>
);

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').then(registration => {
      window.swRegistration = registration;
      const ready = () => window.dispatchEvent(new Event('cad-update-ready'));
      if (registration.waiting) ready();
      registration.addEventListener('updatefound', () => {
        const worker = registration.installing;
        worker?.addEventListener('statechange', () => {
          if (worker.state === 'installed' && navigator.serviceWorker.controller) ready();
        });
      });
      registration.update().catch(() => {});
    }).catch(() => {});
    // Controller changes preserve current forms. No cache purge, IDB deletion or reload.
  });
}
